import axios from 'axios';

// Same-origin everywhere: in prod and UAT the proxy routes /api on every tenant host to the backend,
// and in dev src/setupProxy.js does. So the auth cookie lives on the host the page runs on.
const apiClient = axios.create({
  baseURL: '/api',
  withCredentials: true,
});

export default apiClient;
